
import { InertiaForm } from "@inertiajs/inertia-vue3";
import { defineComponent, PropType } from "vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiCancel, mdiCheck, mdiClose, mdiLoading } from "@mdi/js";

export default defineComponent({
  components: {
    SvgIcon,
  },
  props: {
    form: {
      type: Object as PropType<InertiaForm<any>>,
      required: true,
    },
    eager: {
      type: Boolean,
      default: () => false,
    },
  },
  setup() {
    return {
      loadingIcon: mdiLoading,
      successIcon: mdiCheck,
      failureIcon: mdiClose,
    };
  },
});
